module.exports = __FOREMAN_VENDOR__REDUX_LOGGER__;